<div class="flex w-full items-center justify-between">
  <!-- Desktop Filters -->
  <div class="hidden flex-nowrap gap-3 md:flex">
    <!-- Magazine Filter -->
    <dhp-generic-filter
      [items]="magazines"
      [isOpen]="(dialogConfig$ | async)?.showMagazineDialog ?? false"
      [selectedCount]="(selectedMagazinesCount$ | async) ?? 0"
      [isLoading]="isLoadingMagazines"
      [title]="'components.filter.magazine' | translate"
      (toggleDialog)="toggleDialog('showMagazineDialog')"
      (toggleSelection)="toggleSelection('magazines', $event)"
      (clearSelection)="clearSelection('magazines')"
      (scrolled)="loadMoreIfNeeded('magazines')"
    ></dhp-generic-filter>

    <!-- Temporarily disable type filter because of HOL-1065 -->
    <dhp-generic-filter
      [items]="types"
      [isOpen]="(dialogConfig$ | async)?.showTypeDialog ?? false"
      [selectedCount]="selectedTypesCount$ | async"
      [title]="'components.filter.type' | translate"
      (toggleDialog)="toggleDialog('showTypeDialog')"
      (toggleSelection)="toggleSelection('types', $event)"
      (clearSelection)="clearSelection('types')"
      (scrolled)="loadMoreIfNeeded('types')"
    ></dhp-generic-filter>

    <!-- Author Filter -->
    <dhp-generic-filter
      [items]="authors"
      [isOpen]="(dialogConfig$ | async)?.showAuthorDialog ?? false"
      [selectedCount]="selectedAuthorsCount$ | async"
      [isLoading]="isLoadingAuthors"
      [showSearch]="true"
      [searchTerm]="(searchConfig$ | async)?.authorSearchTerm ?? null"
      [title]="'components.filter.author' | translate"
      [placeholder]="'components.filter.searchAuthor' | translate"
      (toggleDialog)="toggleDialog('showAuthorDialog')"
      (toggleSelection)="toggleSelection('authors', $event)"
      (clearSelection)="clearSelection('authors')"
      (searchTermChange)="onAuthorSearch($event)"
      (scrolled)="loadMoreIfNeeded('authors')"
    ></dhp-generic-filter>
  </div>

  <!-- Mobile Layout -->
  <div class="flex w-full items-center gap-3 md:hidden">
    <!-- Mobile Filter Button -->
    <button
      class="btn flex h-10 w-10 btn-outline p-0"
      (click)="openMobileFilterDialog()"
      type="button"
      aria-label="Open filters"
    >
      <!-- assets/icons/filter.svg -->
      <svg
        class="h-5 w-5"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 11H17V13H7V11ZM4 7H20V9H4V7ZM10 15H14V17H10V15Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </div>
</div>

<!-- Mobile Filter Dialog -->
<dhp-mobile-filter
  [isOpen]="showMobileFilterDialog"
  [magazines]="magazines"
  [authors]="authors"
  [types]="types"
  [expandedSections]="mobileExpandedSections"
  [magazinesSelectedCount]="(selectedMagazinesCount$ | async) ?? 0"
  [authorsSelectedCount]="(selectedAuthorsCount$ | async) ?? 0"
  [typesSelectedCount]="(selectedTypesCount$ | async) ?? 0"
  [totalArticles]="(totalArticles$ | async) ?? 0"
  [isLoadingAuthors]="isLoadingAuthors"
  [authorSearchTerm]="(searchConfig$ | async)?.authorSearchTerm"
  (closeDialog)="closeMobileFilterDialog()"
  (toggleSection)="toggleMobileSection($event)"
  (toggleSelection)="toggleSelection($event.category, $event.item)"
  (clearSelection)="clearSelection($event)"
  (applyFilters)="applyMobileFilters()"
  (resetFilters)="resetAllFilters()"
  (scrollChange)="onMobileScroll($event.event, $event.category)"
  (searchTermChange)="onAuthorSearch($event ?? '')"
></dhp-mobile-filter>
